import FullImageCardWrapper from './full-image-card-view';

export default FullImageCardWrapper;
